import React from 'react'
import { injectIntl } from 'react-intl';

function LoadStatusHeader({ intl }) {
    const { formatMessage } = intl;
    return (
        <div className="top_header_bar border-bottom-0">
            <div className="row">
                <div className="col-sm col-xl-4 d-flex align-items-center">
                    <h3 className="mb-0 h3-heading" title="Payment status"> {formatMessage({ id: "app.header" })}</h3>
                </div>

            </div>
        </div>
    )
}

export default injectIntl(LoadStatusHeader);
